import clsx from 'clsx'
import {forwardRef, PropsWithChildren} from 'react'

interface IWidthLimiterProps extends PropsWithChildren {
  id: string
  classNameOuter?: string
  classNameInner?: string
}

export const ContentWidthLimiter = forwardRef<HTMLDivElement | null, IWidthLimiterProps>(
  ({id, classNameInner, classNameOuter, children}, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'fixed inset-0 flex min-w-[320px] justify-center overflow-hidden px-[24px] lg:px-[64px]',
          classNameOuter,
        )}
        id={id}
      >
        <div
          className={clsx('relative h-full w-full max-w-[720px] lg:max-w-[1280px]', classNameInner)}
        >
          {children}
        </div>
      </div>
    )
  },
)
